// Helper function to find active sidebar item based on current path
export const findActiveItemFromPath = (
  pathname: string,
  sidebarItems: any[]
): string => {
  // Search through sidebar items array using the path property
  for (const item of sidebarItems) {
    // Check children items first (prioritize child items over parent headers)
    if (item.children) {
      for (const child of item.children) {
        if (child.path && pathname === child.path) {
          return child.id;
        }
        // Check if path starts with child path (for dynamic routes)
        if (child.path && pathname.startsWith(child.path)) {
          return child.id;
        }
      }
    }

    // Check parent items only if no children match
    if (item.header?.path && pathname === item.header.path) {
      return item.id;
    }

    // Check if path starts with the item path (for dynamic routes)
    if (item.header?.path && pathname.startsWith(item.header.path)) {
      return item.id;
    }
  }

  // Fallback: additional path matching for common routes
  if (
    pathname.startsWith("/docViewer") ||
    pathname.startsWith("/docViewerAssistant")
  ) {
    return "DocAssistant";
  }
  if (
    pathname.startsWith("/templates") ||
    pathname.startsWith("/forms") ||
    pathname.startsWith("/assigned")
  ) {
    return "docplace-forms-id";
  }
  if (pathname.includes("esignature") || pathname.includes("signature")) {
    return "docplace-esignature-id";
  }
  if (pathname.includes("workflow") || pathname.startsWith("/requested")) {
    return "requestedWF-id";
  }

  return "fileManager"; // default fallback
};

// Helper function to load SVG content from URL
export const loadSvgContent = async (svgUrl: string): Promise<string> => {
  try {
    const response = await fetch(svgUrl);
    if (!response.ok) {
      throw new Error(`Failed to load SVG: ${response.statusText}`);
    }
    const svgContent = await response.text();
    return svgContent;
  } catch (error) {
    console.error("Error loading SVG:", error);
    return "";
  }
};

// Cache for loaded SVG content
const svgCache = new Map<string, string>();

// Helper function to get SVG content with caching
export const getSvgContent = async (svgUrl: string): Promise<string> => {
  if (svgCache.has(svgUrl)) {
    return svgCache.get(svgUrl)!;
  }

  const content = await loadSvgContent(svgUrl);
  if (content) {
    svgCache.set(svgUrl, content);
  }
  return content;
};
